export const loader = async () => {
  return null
}

export const SubscriptionRoseMypageSkip: React.FC = () => {
  return <div>TODO</div>
}
